(function ($, Drupal, once) {
  Drupal.behaviors.sub_menu_desktop = {
    attach: function (context, settings) {
     'use strict';

     // Set 'document' to 'context' if Drupal
     var topLevelLink = context.querySelectorAll('.main-sub-menu_desktop__link--with-sub');
     var closeMenu = context.querySelectorAll('.main-sub-menu-card-grid__close');

     var className = 'is-active';

     // Accordion Toggle
     // Mobile Click Menu Transition
     for (var i = 0; i < topLevelLink.length; i++) {
       $(once("events", topLevelLink[i])).click(function (e) {
         // Add is-active class
         this.parentNode.classList.toggle(className);

        for (var i = 0; i < topLevelLink.length; i++) {
          if(topLevelLink[i] != this && topLevelLink[i].parentNode.classList.contains(className)) {
            topLevelLink[i].parentNode.classList.remove(className);
          }
        }

         e.preventDefault();
       });
     }

     // Mobile Click Menu Transition
     for (var i = 0; i < closeMenu.length; i++) {
      closeMenu[i].addEventListener('click', function (e) {
        // Add is-active class
        this.parentNode.parentNode.parentNode.classList.remove(className);
        e.preventDefault();
      });
    }

   }
  };
})(jQuery, Drupal, once);

